import * as types from 'src/localization/types';

export const localized = (env: types.Env) => ({
  title: env.localizer('components.HelpCreditCard.title'),
  description: env.localizer('components.HelpCreditCard.description'),
  btn: env.localizer('components.HelpCreditCard.btn')
});
